import { render, staticRenderFns } from "./inspectionTaskAssignModal.vue?vue&type=template&id=22007708"
import script from "./inspectionTaskAssignModal.vue?vue&type=script&lang=js"
export * from "./inspectionTaskAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports